export default {
  TITLE: 'Account noch nicht freigeschaltet',
  TITLE_SUCCESS: 'E-Mail wurde versendet',
  TITLE_ERROR: 'Fehler beim Versenden der E-Mail',
  CONTENT_ERROR_1: 'Wir konnten die E-Mail nicht versenden. Bitte versuchen Sie es später erneut.',
  CONTENT_SUCCESS_1: 'Wichtig: Der Link in der E-Mail läuft zwei Stunden nach Erhalt ab. Bitte kontrollieren Sie ggf. auch Ihren Spam-Ordner.',
  CONTENT_1: 'Sie haben sich bereits bei arztpool registriert. Ihr Account ist jedoch noch nicht freigeschaltet. ',
  CONTENT_2: 'Bitte klicken Sie auf "Freischaltungslink erneut senden". Sie erhalten umgehend eine E-Mail.',
  CONTENT_3: 'Wichtig: Der Link in der E-Mail läuft zwei Stunden nach Erhalt ab. Bitte kontrollieren Sie ggf. auch Ihren Spam-Ordner.',
  SUBMIT: 'Freischaltungslink erneut senden',
  CLOSE: 'Schließen',
  SNACKBAR: {
    MESSAGE: 'Aktion erfolgreich durchgeführt'
  }
};
